const Hdivider = () => {
  return <span className="h_divider" />
}

export default Hdivider
